module.exports = __webpack_public_path__ + "img/RX106M.bb5b6cbb.png";